import { render } from "./app-vehicle-options.vue?vue&type=template&id=482b813b&ts=true"
import script from "./app-vehicle-options.vue?vue&type=script&lang=ts"
export * from "./app-vehicle-options.vue?vue&type=script&lang=ts"

import "./app-vehicle-options.vue?vue&type=style&index=0&id=482b813b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__